import * as Yup from 'yup';

const FundraisingNotificationValidator = () => Yup.object({
  contacts: Yup.array()
    .of(Yup.number())
    .when(['send_email_notifications', 'send_sms_notifications'], {
      is: (
        sendEmailNotifications: boolean,
        sendSmsNotifications: boolean,
      ) => sendEmailNotifications || sendSmsNotifications,
      then: (contactsSchema) => contactsSchema
        .required('Contacts are required when notifications are enabled')
        .min(1, 'At least one contact is required'),
      otherwise: (contactsSchema) => contactsSchema.notRequired(),
    }),
  send_thanks_email: Yup.boolean(),
  thanks_email_body: Yup.string().when('send_thanks_email', {
    is: true,
    then: (schema) => schema
      .required('Email body is required when sending thanks email')
      .test(
        'has-text',
        'Email body must contain text',
        (value) => Boolean(value && value.replace(/<[^>]+>/g, '').trim()),
      ),
    otherwise: (schema) => schema.notRequired(),
  }),
  thanks_email_title: Yup.string().when('send_thanks_email', {
    is: true,
    then: (schema) => schema.required('Must enter the Email title'),
    otherwise: (schema) => schema.notRequired(),
  }),
  send_thanks_sms: Yup.boolean(),
  thanks_sms_text: Yup.string().when('send_thanks_sms', {
    is: true,
    then: (schema) => schema.required('Must enter the SMS message'),
    otherwise: (schema) => schema.notRequired(),
  }),
  send_email_notifications: Yup.boolean(),
  send_sms_notifications: Yup.boolean(),
  fb_title: Yup.string()
    .max(75, 'Title must be at most 75 characters')
    .nullable(),
  fb_description: Yup.string()
    .max(250, 'Description must be at most 250 characters')
    .nullable(),
})
  // Object-level test for fb_title / fb_description
  .test(
    'title-description-pair',
    'Title and Description must either both be empty or both be filled.',
    function (formValues) {
      const titleValue = formValues.fb_title?.trim() ?? '';
      const descriptionValue = formValues.fb_description?.trim() ?? '';

      if ((titleValue === '' && descriptionValue === '') || (titleValue !== '' && descriptionValue !== '')) {
        return true;
      }
      if (titleValue === '') {
        return this.createError({
          path: 'fb_title',
          message: 'Title is required if Description is filled.',
        });
      }
      if (descriptionValue === '') {
        return this.createError({
          path: 'fb_description',
          message: 'Description is required if Title is filled.',
        });
      }
      return true;
    },
  );

export default FundraisingNotificationValidator;
